import { useState } from "react";
import { SparkleIcon } from "../../components/icons";
import { useImproveDescription } from "../../lib/queries";

/**
 * "Mejorar descripción" (f4-07): Lumi proposes a sales description from the product's
 * data, shown beside the current one; the person uses it or discards it. Saved changes
 * are what it reads, so new data counts once saved.
 */
export function ImproveDescription({
  productId,
  current,
  dirty,
  onUse,
}: {
  productId: string;
  current: string;
  /** The form has unsaved changes: the proposal would not see them. */
  dirty: boolean;
  onUse: (text: string) => void;
}) {
  const improve = useImproveDescription();
  const [proposal, setProposal] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);

  async function run() {
    setNote(null);
    try {
      const r = await improve.mutateAsync(productId);
      if (r.status === "ok") {
        setProposal(r.description);
        setNote(`Quedan ${r.left} hoy.`);
      } else {
        setNote(
          r.status === "daily_limit"
            ? "Ya se usaron las 30 de hoy. Mañana hay 30 más."
            : "No se pudo escribir la propuesta. Intenta de nuevo.",
        );
      }
    } catch {
      setNote("No se pudo escribir la propuesta. Intenta de nuevo.");
    }
  }

  return (
    <div className="improve">
      <div className="improve-bar">
        <button className="btn btn-sm" type="button" disabled={improve.isPending} onClick={run}>
          <SparkleIcon />
          {improve.isPending ? "Escribiendo…" : proposal ? "Otra propuesta" : "Mejorar descripción"}
        </button>
        <span className="faint">
          {note ??
            (dirty
              ? "Guarda los cambios primero: Lumi escribe con los datos guardados."
              : "Lumi escribe una descripción de venta con los datos del producto.")}
        </span>
      </div>
      {proposal && (
        <div className="improve-compare">
          <section>
            <h4>Actual</h4>
            <p>{current.trim() || <span className="faint">Sin descripción.</span>}</p>
          </section>
          <section className="improve-proposal">
            <h4>Propuesta de Lumi</h4>
            <p>{proposal}</p>
            {proposal.includes("[falta:") && <p className="faint">Completa lo marcado [falta: …] antes de guardar.</p>}
            <div className="row">
              <button className="btn" type="button" onClick={() => setProposal(null)}>
                Descartar
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  onUse(proposal);
                  setProposal(null);
                  setNote("Propuesta copiada en la descripción. Revisa y guarda.");
                }}
              >
                Usar la propuesta
              </button>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}
